import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';

const OtherOption = (props) => {
	const { t, i18n } = useTranslation();
	const dispatch = useDispatch();

	const {fv, checkedValue, option} = props;
	const fieldname = `option_other`;

	const userData = useSelector(state => state.userData);
	const cbModalOtherData = useSelector(state => state.cbModalOtherData);

	useEffect(() => { // to be updated after render
		if (fv) {
			if (checkedValue === 'other') {
				//console.log(`add other validator, fieldname`, fieldname);

				fv.addField(fieldname, {
					validators: {
						notEmpty: {
							message: t('此欄為必須填寫')
						}
					}
				});
			} else {
				const fields = fv.getFields();
				if (fieldname in fields) {
					fv.removeField(fieldname);
				}
			}
		}
	}, [checkedValue, fv]);

	const onChange = (e) => {
		const value = e.target.value;

		dispatch({type: 'SET_CBMODAL_OTHER_DATA', payload: value});
	}

	return (
		<div className="mb-0">
			<span className="flex-shrink-0">{option.label}</span>
			{checkedValue === 'other' && (
				<div className="form-group text">
					<input
						type="text"
						id={fieldname}
						name={fieldname}
						className="form-control-sm mb-3 form-control"
						value={cbModalOtherData}
						onChange={onChange}
					/>
				</div>
			)}
		</div>
	);
}

export default OtherOption;